import React from 'react';
import { Stethoscope, Share2 } from 'lucide-react';

/** Consulting vs referral — first step of appointments. */
export default function BookingIntentStep({ primary, value, onPick, onBack }) {
  const options = [
    {
      id: 'consulting',
      title: 'Consulting / OPD visit',
      hint: 'Book a General Physician slot — faculty, dependent, or guest',
      Icon: Stethoscope,
    },
    {
      id: 'referral',
      title: 'Seeking a referral',
      hint: 'Specialist referral letter via patient portal (not an OPD slot)',
      Icon: Share2,
    },
  ];
  return (
    <div data-testid="booking-intent-step">
      {onBack ? (
        <div className="flex justify-end mb-2">
          <button type="button" onClick={onBack} className="text-[11px] text-zinc-500 hover:text-zinc-300">Back</button>
        </div>
      ) : null}
      <p className="text-[11px] uppercase tracking-wider text-zinc-400 mb-3">What do you need today?</p>
      <div className="space-y-2">
        {options.map(({ id, title, hint, Icon }) => {
          const active = value === id;
          return (
            <button
              key={id}
              type="button"
              onClick={() => onPick(id)}
              className={`w-full text-left rounded-xl border px-4 py-3.5 transition ${
                active ? 'border-white/40 bg-white/10' : 'border-white/12 hover:bg-white/[0.06]'
              }`}
              style={active ? { borderColor: primary, background: `${primary}18` } : {}}
              data-testid={`booking-intent-${id}`}
            >
              <div className="flex items-start gap-3">
                <div
                  className="h-9 w-9 rounded-lg flex items-center justify-center flex-shrink-0"
                  style={{ background: `${primary}22`, color: primary }}
                >
                  <Icon className="h-4 w-4" />
                </div>
                <div>
                  <p className="font-semibold text-zinc-100 text-sm">{title}</p>
                  <p className="text-[11px] text-zinc-500 mt-0.5">{hint}</p>
                </div>
              </div>
            </button>
          );
        })}
      </div>
    </div>
  );
}
